import api from 'core/api';

export const getSpecialtySpaces = () => api.get('specialty-spaces/');

export const getSpecialtySpacesRooms = () => api.get('specialty-spaces/rooms');
